<template>
  <span>{{ process }}</span>
</template>
<script lang="ts">

  export default {
    name: 'processResources',
    props: {
      process: Object
    },
    methods: {
      isValidData() {
        return true
      },
      getDataToStore() {
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>